import React, {useEffect, useState} from "react";

import {HashRouter} from "react-router-dom";
import "./theme/theme.css";
import "./theme/bluetheme.css";
import {Paths} from "./components/sidebar/Paths";
import {giveConsent, initializeGa} from "./utils/Analytics";
import {CookieConsent} from "react-cookie-consent";
import LinkComponent, {ALinkTarget} from "./components/link/LinkComponent";
import SidebarComponent from "./components/sidebar/SidebarComponent";
import ContentComponent from "./components/content/ContentComponent";
import {ColorMode, LightMode} from "./theme/Mode";

export default function App() {
    initializeGa();
    const [lightMode, setLightMode] = useState(localStorage.getItem('lightMode') || LightMode.light)
    const [colorMode, setColorMode] = useState(localStorage.getItem('colorMode') || ColorMode.pink)

    useEffect(() => {
        document.documentElement.setAttribute('color-theme', colorMode)
        document.documentElement.setAttribute('light-theme', lightMode)
    }, [lightMode, colorMode]);

    const toggleLightMode = (newMode) => {
        setLightMode(newMode)
        localStorage.setItem('lightMode', newMode)
    }

    const toggleColorMode = (newMode) => {
        setColorMode(newMode)
        localStorage.setItem('colorMode', newMode)
    }

    return (<HashRouter>
        <div className="App">
            <SidebarComponent toggleLightMode={toggleLightMode} lightMode={lightMode}
                              toggleColorMode={toggleColorMode} colorMode={colorMode}/>
            <ContentComponent/>
            <ConsentComponent/>
        </div>
    </HashRouter>);
}

const ConsentComponent = () => {
    const [consent, setConsent] = useState(false);

    useEffect(() => {
        const hasConsent = document.cookie.indexOf('ga_consent=true') > -1 || consent;
        setConsent(hasConsent);

        if (hasConsent) {
            giveConsent()
        }
    }, []);

    const handleAccept = () => {
        document.cookie = 'ga_consent=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/';
        setConsent(true);
        giveConsent()
    };

    const handleDecline = () => {
        document.cookie = 'ga_consent=false; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/';
        setConsent(false);
    };

    return (<CookieConsent
        location="bottom"
        enableDeclineButton={true}
        buttonText="Accept"
        declineButtonText="Decline"
        overlay={false}
        cookieName="ga_consent"
        onAccept={handleAccept}
        onDecline={handleDecline}
    >
        This website uses Google Analytics 4 to collect information about how users interact with the site. I use
        this information to improve the site and tailor it to your needs. You can opt out of Google Analytics 4 by
        hitting decline. For more information on how Google Analytics 4 uses cookies, please refer to
        Google's <LinkComponent link="https://policies.google.com/technologies/partner-sites">privacy
        policy</LinkComponent>. For
        more information on how I use this data to improve the website, see ShesAMobileDev's <LinkComponent
        link={Paths.privacy.path} target={ALinkTarget.internal}>privacy policy</LinkComponent>.
    </CookieConsent>);
};
